import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        classifiers: '=',
        userIds: '=',
        showNavigationError: '=',
        showAddButton: '=',
        form: '=',
        files: '='
    },
    template: `
        <div class="form">
            <modals-courses-historic-occurrence-employee-customized-filter
                classifiers="vm.classifiers"
                list="vm.list"
                occurrence="vm.occurrence"
            />
            <modals-courses-historic-occurrence-employee-table
                list="vm.list"
                user-ids="vm.userIds"
                show-navigation-error="vm.showNavigationError"
                show-add-button="vm.showAddButton"
                form="vm.form"
                course="vm.course"
                files="vm.files"
            />
        </div>
    `
})
export default class {
    constructor (DATATABLES, MomentService, UserResource, ListFactory) {
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;

        this.list = ListFactory.createWithPagination(UserResource.getUsers.bind(UserResource));
        this.list.pagination.perPage = 25;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/historicOccurrence/employee/customized/index.js